import React, { useEffect, useState } from "react";
import EmployerStatement from "./EmployerStatement";
import EmployeeDetails from "./EmployeeDetails";
import AbsenceDetails from "./AbsenceDetails";
import EmployerDetailsFinal from "./EmployerDetailsFinal";
import moment from "moment";
import {
  EMAILREGEX,
  EIN_ERROR,
  ALPHANUMERICWITHSPACEREGEX,
  COMPANYID,
  ENGLISH,
  FRENCH,
  NUMBER_FORMAT_REGEX,
  ENG_FRENCH,
  TYPEOFRTWTOCOMPAREWITH,
  PREFERED_LANGUAGE_KEYS,
  POST_CODE_REGEX,
  TWODECIMAL_NUMBERREGEX,
  MODAL_SIZE,
  PREFERREDLANGUAGEDRPDATA,
  PREFERREDLANGUAGEDRPDATA_FRENCH,
} from "../../App.config";
import validation from "../../utilities/validation";
import * as utilities from "../../utilities/utils";
import Breadcrumb from "./Breadcrumb";
import Step from "../Step";
import { useRef } from "react";
import ConfirmationModalPopup from "../../containers/Std/ConfirmationModalPopup";
import JobDetailModal from "../../containers/Std/JobDetailModal";
import ManagerDetailModal from "../../containers/Std/ManagerDetailModal";
import AttachmentDescription from "../../containers/Std/AttachmentDescription";
import { useSelector } from "react-redux";
import ApplicationPending from '../../containers/PendingApplication'
import history from "../../utilities/history";
import swal from 'sweetalert';
import DisplayEmployeeName from "../../containers/DisplayEmployeeName";

const STD = (props) => {
  let initialState = {
    selectedFilterValue: {
      value: null,
      isDropdown: true,
      ref: useRef(),
      name: "filterValue",
      isSearchOption: true,
    },
    searchBy: {
      value: "EIN",
    },
    clientInfo: {
      value: [],
    },
    searchValue: {
      value: "",
    },
    proceedInLang: {
      value: "English",
    },
    employeeBasicInformationId: {
      value: null
    },
    employeeDetailsId: {
      value: null
    },
    employementInformationId: {
      value: null
    },
    absenseDetailsId: {
      value: null
    },
    employeeQuestionConcernId: {
      value: null
    },
    workObservationId: {
      value: null
    },
    firstName: {
      value: "",
      error: "",
      validation: {
        required: true,
        matchPattern: ALPHANUMERICWITHSPACEREGEX,
      },
      ref: useRef(),
      step: 1,
      positionCount: 1,
      label: "STD-Employer-Statement.form.label.text.FirstName",
      isEditable: true
    },
    lastName: {
      value: "",
      error: "",
      validation: {
        required: true,
        matchPattern: ALPHANUMERICWITHSPACEREGEX,
      },
      ref: useRef(),
      step: 1,
      label: "STD-Employer-Statement.form.label.text.LastName",
      positionCount: 2,
      isEditable: true
    },
    location: {
      value: [],
      error: "",
      validation: {
        required: true,
      },
      ref: useRef(),
      step: 2,
      label: "STD-Employer-Statement.form.dropdown.text.Division/Location",
      positionCount: 11,
      isEditable: true
    },
    serviceType: {
      value: ["STD"],
      error: "",

      validation: {
        required: true,
      },
      ref: useRef(),
      step: 1,
      label: "STD-Employer-Statement.form.label.text.serviceType",
      positionCount: 5,
    },
    dateOfBirth: {
      value: "",
      error: "",

      validation: {
        isDate: true,
      },
      ref: useRef(),
      step: 1,
      label:
        "STD-Employer-Statement.form.Employee-Details.calender.text.Birth-Date",
      positionCount: 4,
      isEditable: true
    },
    phone: {
      value: "",
      error: "",
      validation: {
        required: true,
        matchPattern: NUMBER_FORMAT_REGEX,
        type: "Phone Number",
      },
      ref: useRef(),
      step: 2,
      label: "STD-Employer-Statement.form.Employer-Details.label.text.Phone",
      positionCount: 6,
      isEditable: true
    },
    alternativePhone: {
      value: "",
      error: "",
      validation: {
        matchPattern: NUMBER_FORMAT_REGEX,
        type: "Phone Number",
      },
      ref: useRef(),
      step: 2,
      label:
        "STD-Employer-Statement.form.Employer-Details.label.text.Alternate-Phone",
      positionCount: 7,
      isEditable: true
    },
    alternativePhoneType: {
      value: "Work",
    },
    ext: {
      value: "",
    },
    prefferedLanguage: {
      value: [],
      error: "",
      validation: {
        required: true,
      },
      ref: useRef(),
      step: 2,
      label:
        "STD-Employer-Statement.form.Employee-Details.dropdown.text.Employee-Language",
      positionCount: 9,
      isEditable: true
    },
    street: {
      value: "",
      error: "",

      validation: {
        required: true,
      },
      ref: useRef(),
      step: 2,
      label: "STD-Employer-Statement.form.Employee-Details.label.text.Address",
      positionCount: 1,
      isEditable: true
    },
    city: {
      value: "",
      error: "",
      validation: {
        required: true,
      },
      ref: useRef(),
      step: 2,
      label: "STD-Employer-Statement.form.Employee-Details.label.text.City",
      positionCount: 4,
      isEditable: true
    },
    country: {
      value: [],
      error: "",
      validation: {
        required: true,
      },
      ref: useRef(),
      step: 2,
      label: "STD-Employer-Statement.form.Employee-Details.label.text.Country",
      positionCount: 2,
    },
    state: {
      value: [],
      error: "",
      validation: {
        required: true,
      },
      ref: useRef(),
      step: 2,
      label: "STD-Employer-Statement.form.Employee-Details.label.text.Province",
      positionCount: 3,
      isEditable: true
    },
    postalCode: {
      value: "",
      error: "",
      validation: {
        required: true,
        matchPattern: POST_CODE_REGEX,
        type: "Postal Code",
      },
      ref: useRef(),
      label: "STD-Employer-Statement.form.Employee-Details.label.text.Postal",
      positionCount: 5,
      step: 2,
      isEditable: true
    },
    typeOfWork: {
      value: [],
    },
    ein: {
      value: "",
      error: "",

      validation: {
        required: true,
      },
      ref: useRef(),
      step: 1,
      label: "STD-Employer-Statement.form.label.text.Employee-ID/EIN",
      positionCount: 3,
      isEditable: true
    },
    employeeEmail: {
      value: "",
      error: "",
      validation: {
        matchPattern: EMAILREGEX,
        type: "Email",
      },
      ref: useRef(),
      label: "STD-Employer-Statement.form.Employee-Details.label.text.Email",
      positionCount: 8,
      step: 2,
      isEditable: true
    },
    employeeEmailType: {
      value: "Personal",
    },
    decreasedHours: {
      value: "No",
    },
    sTDExpiryDate: {
      value: "",
    },
    alteredDuties: {
      value: "No",
    },
    isAlteredDutiesYes: {
      value: "",
    },
    eligibleLTD: {
      value: "NA",
    },
    jobTitle: {
      value: "",
      error: "",
      validation: {
        required: true,
      },
      ref: useRef(),
      label: "STD-Employer-Statement.form.Employee-Details.label.text.Job",
      positionCount: 12,
      step: 2,
      isEditable: true
    },
    dateOfHire: {
      value: "",
      error: "",
      validation: {
        isDate: true,
      },
      ref: useRef(),
      label:
        "STD-Employer-Statement.form.Employee-Details.label.calender.Date-Of-Hire",
      positionCount: 14,
      step: 2,
      isEditable: true
    },
    contractExpiryDate: {
      value: "",
      error: "",
      validation: {
        // isDate: true,
      },
      ref: useRef(),
      label:
        "STD-Employer-Statement.form.Employee-Details.label.calender.Contract-Expiry-Date",
      positionCount: 15,
      step: 2,
    },
    employmentStatus: {
      value: [],
    },
    department: {
      value: [],
    },
    departmentName: {
      value: "",
      isEditable: true
    },
    planLink: {
      value: [],
      error: "",
      validation: {
        required: true,
      },
      ref: useRef(),
      label:
        "STD-Employer-Statement.form.Employee-Details.label.text.Plan-Type",
      positionCount: 13,
      step: 2,
    },
    region: {
      value: [],
      error: "",
      validation: {
        //required: true,
      },
      ref: useRef(),
      label: "STD-Employer-Statement.form.dropdown.text.Region",
      positionCount: 10,
      step: 2,
    },
    enableWorkShift: {
      value: "No",
    },
    workShifts: {
      value: "",
    },
    lastDayWorked: {
      value: "",
    },
    compensationPending: {
      value: "NA",
    },
    workPlaceAccident: {
      value: "NA",
    },
    caseForAutomobileWage: {
      value: "NA",
    },
    firstDayAbsent: {
      value: "",
      error: "",
      validation: {
        isDate: true,
      },
      ref: useRef(),
      label:
        "STD-Employer-Statement.form.Absence-Details.label.text.First-Day-Absent",
      positionCount: 1,
      step: 3,
    },
    enableReturnToWork: {
      value: "No",
    },
    returnToWork: {
      value: "",
    },
    fileStatus: {
      value: [],
    },
    fileStatusText: {
      value: "",
    },
    previousStdLtd: {
      value: [
        {
          stdLtd: [],
          stdLtdDate: "",
          stdLtdRtwDate: "",
          default: true,
        },
      ],
    },
    observedChanges: {
      value: "No",
    },
    isObservedChanges: {
      value: "",
    },
    behaviorChanges: {
      value: "No",
    },
    isBehaviorChanges: {
      value: "",
    },
    discuss: {
      value: "No",
    },
    formCompletedBy: {
      value: "",
    },
    title: {
      value: "",
    },
    email: {
      value: "",
    },
    emailCopy: {
      value: "",
    },
    date: {
      value: 0,
    },
    stdPlanName: {
      value: "",
    },
    attachment: {
      value: null,
    },
    other: { value: "" },
    typeOfWorkOther: { value: "" },
    isSubmitOnce: { value: false },
    isOtherHasSelected: { value: false },
    isFileStatusSelected: { value: false },
    isTypeOfWorkOtherHasSelected: { value: false },
    isSearchByLastName: {
      value: false,
    },
    weekWDH: {
      value: [
        {
          shift: "Mon",
          name: "Mon",
          hours: "8.0",
          employeeShiftInformationId: null,
          employeeBasicInfoId: null
        },
        {
          shift: "Tue",
          name: "Tue",
          hours: "8.0",
          employeeShiftInformationId: null,
          employeeBasicInfoId: null
        },
        {
          shift: "Wed",
          name: "Wed",
          hours: "8.0",
          employeeShiftInformationId: null,
          employeeBasicInfoId: null
        },
        {
          shift: "Thus",
          name: "Thus",
          hours: "8.0",
          employeeShiftInformationId: null,
          employeeBasicInfoId: null
        },
        {
          shift: "Fri",
          name: "Fri",
          hours: "8.0",
          employeeShiftInformationId: null,
          employeeBasicInfoId: null
        },
        {
          shift: "Sat",
          name: "Sat",
          hours: "0.0",
          employeeShiftInformationId: null,
          employeeBasicInfoId: null
        },
        {
          shift: "Sun",
          name: "Sun",
          hours: "0.0",
          employeeShiftInformationId: null,
          employeeBasicInfoId: null
        },
      ],
    },
    workDay: {
      value: "FullTime",
    },
    otherEmploymentStatus: {
      value: "",
    },
    isEnableSearch: {
      value: false,
    },
    informationForReview: {
      value: "",
    },
    termsAndCondition: {
      value: "",
    },
    fileContactManagerName: {
      value: "",
      error: "",
      validation: {
        //required: true,
      },
      ref: useRef(),
      //label: "STD-Employer-Statement.form.Employee-Details.label.text.Job",
      positionCount: 12,
      step: 2,
      isEditable: true
    },
    managerName: {
      value: [],
      error: "",
      ref: useRef(),
      label:
        "STD-Employer-Statement.form.Employee-Details.label.text.Manager-Name",
      positionCount: 16,
      step: 2,
      isEditable: true
    },
    managerPhone: {
      value: "",
      error: "",
      isEditable: true,
      validation: {
        required: true,
        matchPattern: NUMBER_FORMAT_REGEX,
        type: "Phone Number",
      },
      ref: useRef(),
      label:
        "STD-Employer-Statement.form.Employee-Details.label.text.Manager-Phone",
      positionCount: 17,
      step: 2,
    },
    managerEmailCopy: {
      value: "",
      error: "",
      ref: useRef(),
      step: 4,
    },
    managerEmail: {
      value: "",
      error: "",
      isEditable: true,
      ref: useRef(),
      label:
        "STD-Employer-Statement.form.Employee-Details.label.text.Manager-Email",
      positionCount: 18,
      step: 2,
    },
    futureCommunication: {
      value: props.managersDetails.languagePreference ? FRENCH : ENGLISH,
    },
    federalNetExemptionCode: {
      value: "",
      error: "",
      validation: {},
      ref: useRef(),
      label:
        "STD-Employer-Statement.form.Employer-Details.payroll.label.text.Federal-Net-Exemption",
      positionCount: 1,
      step: 4,
    },
    federalNetExemption: {
      value: "",
      error: "",
      validation: {},
      ref: useRef(),
      label:
        "STD-Employer-Statement.form.Employer-Details.payroll.label.text.Net-Claim-Exemption",
      positionCount: 2,
      step: 4,
    },
    provincialNetExemptionCode: {
      value: "",
      error: "",
      validation: {},
      ref: useRef(),
      label:
        "STD-Employer-Statement.form.Employer-Details.payroll.label.text.Provincial-Net-Exemption",
      positionCount: 3,
      step: 4,
    },
    provincialNetExemption: {
      value: "",
      error: "",
      validation: {},
      ref: useRef(),
      label:
        "STD-Employer-Statement.form.Employer-Details.payroll.label.text.Net-Claim-Exemption",
      positionCount: 4,
      step: 4,
    },
    salary: {
      value: "",
      error: "",
      validation: {},
      ref: useRef(),
      label:
        "STD-Employer-Statement.form.Employer-Details.payroll.label.text.Salary",
      positionCount: 5,
      step: 4,
    },
    salaryPer: {
      value: "Hour",
    },
    payFrequency: {
      value: "",
      error: "",
      validation: {},
      ref: useRef(),
      label:
        "STD-Employer-Statement.form.Employer-Details.payroll.label.text.Pay-Frequency",
      positionCount: 6,
      step: 4,
    },
    totalPaidOutCpp: {
      value: "",
      error: "",
      validation: {},
      ref: useRef(),
      label:
        "STD-Employer-Statement.form.Employer-Details.payroll.label.text.CPP",
      positionCount: 7,
      step: 4,
    },
    totalPaidOutEi: {
      value: "",
      error: "",
      validation: {},
      ref: useRef(),
      label:
        "STD-Employer-Statement.form.Employer-Details.payroll.label.text.EI",
      positionCount: 8,
      step: 4,
    },
    totalPaidOutQpip: {
      value: "",
      error: "",
      validation: {},
      ref: useRef(),
      label:
        "STD-Employer-Statement.form.Employer-Details.payroll.label.text.QPIP",
      positionCount: 9,
      step: 4,
    },

    maxedCpp: {
      value: "",
      error: "",
      validation: {},
      ref: useRef(),
      label:
        "STD-Employer-Statement.form.Employer-Details.payroll.label.text.CPP",
      positionCount: 10,
      step: 4,
    },
    maxedEi: {
      value: "",
      error: "",
      validation: {},
      ref: useRef(),
      label:
        "STD-Employer-Statement.form.Employer-Details.payroll.label.text.EI",
      positionCount: 11,
      step: 4,
    },
    maxedQpip: {
      value: "",
      error: "",
      validation: {},
      ref: useRef(),
      label:
        "STD-Employer-Statement.form.Employer-Details.payroll.label.text.QPIP",
      positionCount: 12,
      step: 4,
    },
    payrollVerbiage: {
      value: "",
      error: "",
      validation: {},
      ref: useRef(),
      label:
        "STD-Employer-Statement.form.Employer-Details.payroll.label.text.Select-Add-payroll-verbiage",
      step: 4,
    },
    additionalNotes: {
      value: "",
      error: "",
      validation: {},
      ref: useRef(),
      label:
        "STD-Employer-Statement.form.Employer-Details.payroll.label.text.Additional-Notes",
      positionCount: 13,
      step: 4,
    },
    additionalNotesAdd: {
      value: "",
      error: "",
      validation: {},
      ref: useRef(),
      label:
        "STD-Employer-Statement.form.Employer-Details.payroll.label.text.Additional-Notes",
      positionCount: 14,
      step: 4,
    },
    administerPayroll: {
      value: "",
    },
  };


  const [state, setState] = useState(initialState);
  const attachmentRef = useRef();
  const updatedReturnToWorkRef = useRef();
  const updatedTypeOfWorkRef = useRef();
  // const [isYourFirstVisit,setIsYourFirstVisit] = useState(true);
  const [urlLocation, setUrlLocation] = useState(props.urlLocation);
  const [selectedValueSave, setselectedValueSave] = useState(undefined);
  const [saveAppSave, setSaveAppSave] = useState(undefined);

  const filterApplicationState = useSelector(
    (state) => state.filterReducer
  );

  //Add new field on Other value
  const onEmploymentStatusChange = () => {
    if (
      utilities.extractFirstValueOfArray(state.employmentStatus.value) ===
      "Other"
    ) {
      setState((state) => {
        return {
          ...state,
          isOtherHasSelected: utilities.convertIntoObject(true),
        };
      });
    } else {
      setState((state) => {
        return {
          ...state,
          isOtherHasSelected: utilities.convertIntoObject(false),
        };
      });
    }
  };

  const onFilterDropDownChange = (selectItems, event) => {

    onDiscard();

    let selectedValue = undefined;

    //Find The value  from array for binding
    Array.isArray(filterApplicationState.filterApplicationValues) &&
      filterApplicationState.filterApplicationValues.map((option, key) => {
        if (selectItems && selectItems.value === option.externalID) {
          selectedValue = option;
        }
      })

    onFilterDrpChange(selectedValue);

    let updatedObj = state.selectedFilterValue;
    updatedObj.value = selectItems;
    setState((state) => {
      return {
        ...state,
        selectedFilterValue: updatedObj,
      };
    });
  }

  //Add new field on Other value
  const onTypeOfWorkChange = () => {
    if (
      TYPEOFRTWTOCOMPAREWITH.includes(
        utilities.extractFirstValueOfArray(state.typeOfWork.value)
      )
    ) {
      setState((state) => {
        return {
          ...state,
          isTypeOfWorkOtherHasSelected: utilities.convertIntoObject(true),
          // typeOfWorkOther: utilities.convertIntoObject(""),
        };
      });
    } else {
      setState((state) => {
        return {
          ...state,
          isTypeOfWorkOtherHasSelected: utilities.convertIntoObject(false),
          typeOfWorkOther: utilities.convertIntoObject(""),
        };
      });
    }
  };

  /// Validation showing in advance in another form steps
  const onStepCountChange = () => {
    for (const property in state) {
      if (
        state[property]?.validation &&
        Object.keys(state[property].validation).length
      ) {
        if (
          state[property]?.error.length > 0 &&
          state[property]?.step === props.stepCount
        ) {
          state[property].error = "";
          setState((previousState) => {
            return {
              ...previousState,
              [property]: state[property],
              isSubmitOnce: utilities.convertIntoObject(false),
            };
          });
        }
      }
    }
  };

  //is search by lastname
  const onSearchFilterChange = () => {
    if (state.searchBy.value === "LastName") {
      setState((state) => {
        return {
          ...initialState,
          searchBy: utilities.convertIntoObject(state.searchBy.value),
          isSearchByLastName: utilities.convertIntoObject(true),
        };
      });
      props.setIsSearch(false);
    } else {
      setState((state) => {
        return {
          ...initialState,
          clientInfo: utilities.convertIntoObject(
            initialState.clientInfo.value,
            initialState.clientInfo
          ),
          isSearchByLastName: utilities.convertIntoObject(false),
        };
      });
      props.setIsSearch(false);
    }
  };

  // Add/Remove validation dynamically to field
  const onReturnToWorkChange = () => {
    let updatedReturnToWork = state.returnToWork;
    let updatedTypeOfWork = state.typeOfWork;
    if (state.enableReturnToWork.value === "Yes") {
      updatedReturnToWork.validation = {
        isDate: true,
      };
      updatedTypeOfWork.validation = {
        required: true,
      };
      updatedReturnToWork.step = 3;
      updatedReturnToWork.label =
        "STD-Employer-Statement.form.Absence-Details.label.text.Date-Of-Rtw";
      updatedReturnToWork.positionCount = 2;
      updatedTypeOfWork.step = 3;
      updatedTypeOfWork.label =
        "STD-Employer-Statement.form.Absence-Details.label.text.Type-Of-Rtw";
      updatedTypeOfWork.positionCount = 3;
      updatedReturnToWork.error = "";
      updatedTypeOfWork.error = "";

      updatedReturnToWork.ref = updatedReturnToWorkRef;
      updatedTypeOfWork.ref = updatedTypeOfWorkRef;

      setState((state) => {
        return {
          ...state,
          returnToWork: updatedReturnToWork,
          typeOfWork: updatedTypeOfWork,
          isSubmitOnce: utilities.convertIntoObject(false),
        };
      });
    } else {
      if (updatedReturnToWork.validation || updatedTypeOfWork.validation) {
        delete updatedReturnToWork.validation;
        delete updatedReturnToWork.error;
        delete updatedReturnToWork.step;
        delete updatedReturnToWork.label;
        delete updatedReturnToWork.positionCount;

        delete updatedTypeOfWork.positionCount;
        delete updatedTypeOfWork.label;
        delete updatedTypeOfWork.validation;
        delete updatedTypeOfWork.error;
        delete updatedTypeOfWork.step;

        updatedReturnToWork.value = "";
        updatedTypeOfWork.value = [];
        setState((state) => {
          return {
            ...state,
            returnToWork: updatedReturnToWork,
            typeOfWork: updatedTypeOfWork,
          };
        });
      }
    }
  };

  const onAdministerPayrollChange = () => {
    let updatedFederalNetExemption = state.federalNetExemption;
    let updatedProvincialNetExemptionCode = state.provincialNetExemptionCode;
    let updatedProvincialNetExemption = state.provincialNetExemption;
    let updatedSalary = state.salary;
    let updatedPayFrequency = state.payFrequency;
    let updatedTotalPaidOutCpp = state.totalPaidOutCpp;
    let updatedTotalPaidOutEi = state.totalPaidOutEi;
    let updatedFederalNetExemptionCode = state.federalNetExemptionCode;
    let updatedMaxedCpp = state.maxedCpp;
    let updatedMaxedEi = state.maxedEi;
    let updatedMaxedQpip = state.maxedQpip;
    let updatedAdditionalNotes = state.additionalNotes;
    let updatedPayrollVerbiage = state.payrollVerbiage;
    let updatedTotalPaidOutQpip = state.totalPaidOutQpip;
    if (state.administerPayroll.value) {
      updatedFederalNetExemptionCode.validation = { required: true };
      updatedFederalNetExemption.validation = { required: true };
      updatedProvincialNetExemptionCode.validation = { required: true };
      updatedProvincialNetExemption.validation = { required: true };
      updatedSalary.validation = {
        required: true,
        matchPattern: TWODECIMAL_NUMBERREGEX,
        type: "Number",
      };
      updatedPayFrequency.validation = {
        required: true,
        matchPattern: /^[a-zA-Z0-9\s&\/\-_]{1,50}$/,
        type: "Text",
      };
      updatedTotalPaidOutCpp.validation = {
        required: true,
        matchPattern: TWODECIMAL_NUMBERREGEX,
        type: "Number",
      };

      updatedTotalPaidOutEi.validation = {
        required: true,
        matchPattern: TWODECIMAL_NUMBERREGEX,
        type: "Number",
      };
      updatedTotalPaidOutQpip.validation = {
        matchPattern: TWODECIMAL_NUMBERREGEX,
        type: "Number",
      };
      updatedMaxedCpp.validation = {
        matchPattern: TWODECIMAL_NUMBERREGEX,
        type: "Number",
      };

      updatedMaxedEi.validation = {
        matchPattern: TWODECIMAL_NUMBERREGEX,
        type: "Number",
      };

      updatedMaxedQpip.validation = {
        matchPattern: TWODECIMAL_NUMBERREGEX,
        type: "Number",
      };

      updatedPayrollVerbiage.validation = {
        matchPattern: /^[a-zA-Z0-9\s&\/\-_]{0,50}$/,
        type: "Text",
      };
      setState((state) => {
        return {
          ...state,
          federalNetExemptionCode: updatedFederalNetExemptionCode,
          federalNetExemption: updatedFederalNetExemption,
          provincialNetExemptionCode: updatedProvincialNetExemptionCode,
          provincialNetExemption: updatedProvincialNetExemption,
          salary: updatedSalary,
          payFrequency: updatedPayFrequency,
          totalPaidOutCpp: updatedTotalPaidOutCpp,
          totalPaidOutEi: updatedTotalPaidOutEi,
          payrollVerbiage: updatedPayrollVerbiage,
          totalPaidOutQpip: updatedTotalPaidOutQpip,
          maxedCpp: updatedMaxedCpp,
          maxedEi: updatedMaxedEi,
          maxedQpip: updatedMaxedQpip,
          isSubmitOnce: utilities.convertIntoObject(false),
        };
      });
    } else {
      delete updatedFederalNetExemptionCode.validation;
      updatedFederalNetExemptionCode.error = "";
      updatedFederalNetExemptionCode.value = "";

      delete updatedFederalNetExemption.validation;
      updatedFederalNetExemption.error = "";
      updatedFederalNetExemption.value = "";

      delete updatedProvincialNetExemptionCode.validation;
      updatedProvincialNetExemptionCode.error = "";
      updatedProvincialNetExemptionCode.value = "";

      delete updatedProvincialNetExemption.validation;
      updatedProvincialNetExemption.error = "";
      updatedProvincialNetExemption.value = "";

      delete updatedSalary.validation;
      updatedSalary.error = "";
      updatedSalary.value = "";

      delete updatedPayFrequency.validation;
      updatedPayFrequency.error = "";
      updatedPayFrequency.value = "";

      delete updatedTotalPaidOutCpp.validation;
      updatedTotalPaidOutCpp.error = "";
      updatedTotalPaidOutCpp.value = "";

      delete updatedTotalPaidOutEi.validation;
      updatedTotalPaidOutEi.error = "";
      updatedTotalPaidOutEi.value = "";

      delete updatedTotalPaidOutQpip.validation;
      updatedTotalPaidOutQpip.error = "";
      updatedTotalPaidOutQpip.value = "";

      delete updatedMaxedCpp.validation;
      updatedMaxedCpp.value = "";
      updatedMaxedCpp.error = "";

      delete updatedMaxedEi.validation;
      updatedMaxedEi.value = "";
      updatedMaxedEi.error = "";

      delete updatedMaxedQpip.validation;
      updatedMaxedQpip.value = "";
      updatedMaxedQpip.error = "";

      updatedAdditionalNotes.value = "";

      delete updatedPayrollVerbiage.validation;
      updatedPayrollVerbiage.value = "";
      updatedPayrollVerbiage.error = "";

      setState((state) => {
        return {
          ...state,
          federalNetExemptionCode: updatedFederalNetExemptionCode,
          federalNetExemption: updatedFederalNetExemption,
          provincialNetExemptionCode: updatedProvincialNetExemptionCode,
          provincialNetExemption: updatedProvincialNetExemption,
          salary: updatedSalary,
          payFrequency: updatedPayFrequency,
          totalPaidOutCpp: updatedTotalPaidOutCpp,
          totalPaidOutEi: updatedTotalPaidOutEi,
          maxedCpp: updatedMaxedCpp,
          maxedEi: updatedMaxedEi,
          maxedQpip: updatedMaxedQpip,
          additionalNotes: updatedAdditionalNotes,
          payrollVerbiage: updatedPayrollVerbiage,
          totalPaidOutQpip: updatedTotalPaidOutQpip,
        };
      });
    }
  };

  const onManagerNameChange = () => {
    if (
      Array.isArray(state.managerName.value) &&
      state.managerName.value.length
    ) {
      let { primaryPhone, primaryEmail, primaryName } = props.supervisorList.find(
        (manager) =>
          manager.supervisorID_PK ===
          utilities.extractFirstValueOfArray(state.managerName.value)
      );
      let managerTelephone = utilities.convertIntoObject(
        normalizeInput(primaryPhone, null),
        state.managerPhone
      );

      let managerEmail = utilities.convertIntoObject(
        primaryEmail,
        state.managerEmail
      );

      let fileContactManagerName = utilities.convertIntoObject(
        primaryName,
        state.fileContactManagerName
      );

      if (managerTelephone.value) {
        managerTelephone.isEditable = false;
      }
      else {
        managerTelephone.isEditable = true;
      }
      if (managerEmail.value) {
        managerEmail.isEditable = false;
      }
      else {
        managerEmail.isEditable = true;
      }
      if (fileContactManagerName.value) {
        fileContactManagerName.isEditable = false;
      }
      else {
        fileContactManagerName.isEditable = true;
      }

      setState((state) => {
        return {
          ...state,
          managerPhone: managerTelephone && managerTelephone.value ? managerTelephone : state.managerPhone,
          managerEmail: managerEmail && managerEmail.value ? managerEmail : state.managerEmail,
          fileContactManagerName: fileContactManagerName && fileContactManagerName.value ? fileContactManagerName : state.fileContactManagerName,
        };
      });


    }
    else {

      let managerPhone1 = utilities.convertIntoObject(
        "",
        state.managerPhone
      );

      let managerEmail1 = utilities.convertIntoObject(
        "",
        state.managerEmail
      );

      managerPhone1.isEditable = true;
      managerEmail1.isEditable = true;
      setState((state) => {
        return {
          ...state,
          managerPhone: managerPhone1,
          managerEmail: managerEmail1,
        };
      });
    }
  };

  // Add/Remove validation dynamically to field
  const onObservedChange = () => {
    let updatedObservedChange = state.isObservedChanges;

    if (state.observedChanges.value === "Yes") {
      updatedObservedChange.validation = {
        required: true,
      };
      updatedObservedChange.step = 4;
      updatedObservedChange.error = "";

      setState((state) => {
        return {
          ...state,
          isObservedChanges: updatedObservedChange,
          isSubmitOnce: utilities.convertIntoObject(false),
        };
      });
    } else {
      if (updatedObservedChange.validation) {
        delete updatedObservedChange.validation;
        delete updatedObservedChange.error;
        delete updatedObservedChange.step;

        updatedObservedChange.value = "";

        setState((state) => {
          return {
            ...state,
            isObservedChanges: updatedObservedChange,
          };
        });
      }
    }
  };

  // Add/Remove validation dynamically to field
  const onBehaviorChange = () => {
    let updatedBehaviorChange = state.isBehaviorChanges;

    if (state.behaviorChanges.value === "Yes") {
      updatedBehaviorChange.validation = {
        required: true,
      };
      updatedBehaviorChange.step = 4;
      updatedBehaviorChange.error = "";

      setState((state) => {
        return {
          ...state,
          isBehaviorChanges: updatedBehaviorChange,
          isSubmitOnce: utilities.convertIntoObject(false),
        };
      });
    } else {
      if (updatedBehaviorChange.validation) {
        delete updatedBehaviorChange.validation;
        delete updatedBehaviorChange.error;
        delete updatedBehaviorChange.step;

        updatedBehaviorChange.value = "";

        setState((state) => {
          return {
            ...state,
            isBehaviorChanges: updatedBehaviorChange,
          };
        });
      }
    }
  };

  //on Employee change call api
  const onClientChange = () => {
    if (state.searchBy.value === "LastName") {
      // props.setIsSearch(true);
      props.getClientInfoByIdOrEin(
        null,
        utilities.extractFirstValueOfArray(state.clientInfo.value)
      );
    }
  };

  // Map fetched data to state
  const mapClientInfoById = () => {
    if (props.clientInfoById) {
      setState((state) => {
        return {
          ...initialState,
          isSearchByLastName: utilities.convertIntoObject(
            state.isSearchByLastName.value
          ),
          searchValue: utilities.convertIntoObject(state.searchValue.value),
          searchBy: utilities.convertIntoObject(state.searchBy.value),
          clientInfo: utilities.convertIntoObject(state.clientInfo.value),
          firstName: utilities.convertIntoObject(
            props.clientInfoById.firstName
          ),
          lastName: utilities.convertIntoObject(props.clientInfoById.lastName),
          postalCode: utilities.convertIntoObject(
            props.clientInfoById.postalcode
          ),
          country: utilities.convertIntoObject(utilities.convertIntoArray(1)),
          state: utilities.convertIntoObject(
            utilities.convertIntoArray(props.clientInfoById.province)
          ),
          dateOfBirth: utilities.convertIntoObject(
            utilities.date(props.clientInfoById.dateOfBirth)
          ),
          department: utilities.convertIntoObject(
            utilities.convertIntoArray(props.clientInfoById.departmentId)
          ),
          street: utilities.convertIntoObject(
            props.clientInfoById.streetNumber
          ),
          ein: utilities.convertIntoObject(props.clientInfoById.ein),
          phone: utilities.convertIntoObject(
            props.clientInfoById.bestPhoneToBeReached
          ),
          dateOfHire: utilities.convertIntoObject(
            utilities.date(props.clientInfoById.dateOfHire)
          ),
          jobTitle: utilities.convertIntoObject(props.clientInfoById.jobtitle),
          planLink: utilities.convertIntoObject(
            utilities.convertIntoArray(props.clientInfoById.planLink)
          ),
          region: utilities.convertIntoObject(
            utilities.convertIntoArray(props.clientInfoById.coRegionID_FK)
          ),
          location: utilities.convertIntoObject(
            utilities.convertIntoArray(props.clientInfoById.locationID_FK)
          ),
        };
      });
    }
  };

  //Open pendingApplication model on page load
  useEffect(() => {
    callModal();
    return function cleanup() {
      props.closeRemoveModal();
    };
  }, []);

  // useEffect(() => {
  //   if(props.notificationReducer && props.notificationReducer.isOnSubmit){
  //     props.getAllPendingApplications(props.managersDetails.managerId);
  //     props.setOnSubmit(false);
  //   }
  // }, [props.notificationReducer.isOnSubmit]);

  const callModal = () => {
    props.getAllPendingApplications(props.managersDetails.managerId);
  }

  // To Open model if there is any pending applications
  useEffect(() => {
    let length = 0;
    props.allPendingApplications && props.allPendingApplications.map((pendingApplication) => {
      length = pendingApplication.applicationType == "STD" ? length + 1 : length;
    })

    if (length > 0) {
      if (urlLocation && urlLocation.state && urlLocation.state.isRedirectFromNotification) {
        props.openSetModalAction(<ApplicationPending applicationType="STD" />, MODAL_SIZE.MODAL_MD);
      }
    }


    props.resetSTDReducer();
    props.setCurrentFormStep(1);
    setState((state) => {
      return {
        ...initialState
      };
    });
  }, [props.allPendingApplications.length])


  // Set value received from DB
  useEffect(() => {
    if (props.contiuedPendingApplicationObj)
      setSTDvalues();
  }, [props.contiuedPendingApplicationObj])


  const convertLanguageToBool = (langname) => {
    if (langname == "CFR") return true
    return false
  }

  const convertPreferredLanguageBoolean = (lang) => {
    if (lang === ENGLISH || lang === ENG_FRENCH) {
      return false;
    }
    return true;
  };

  const setValueToStateForDrpId = (key, valueToBeSet, findFromOptions, optionsKey, optionsValue) => {
    let updatedObj = state[key];
    updatedObj.value = [];
    let editableStatus = true;
    if (!valueToBeSet) {
      updatedObj.value = [];
    }
    Array.isArray(findFromOptions) && findFromOptions.map((option) => {
      if (option[optionsValue] === valueToBeSet) {
        updatedObj.value = [option[optionsKey]]
        updatedObj.isEditable = false;
        editableStatus = false;
      }
    })
    if (editableStatus)
      updatedObj.isEditable = true;
    return updatedObj;
  }

  const setValueToStateForDrpByIdValue = (key, valueToBeSet, findFromOptions, optionsKey, optionsValue) => {
    let updatedObj = state[key];
    let editableStatus = true;
    Array.isArray(findFromOptions) && findFromOptions.map((option) => {
      let optionVal = option[optionsKey] == "ENG" ? false : true;
      if (optionVal === valueToBeSet) {
        updatedObj.value = [option[optionsKey]]
        updatedObj.isEditable = false;
        editableStatus = false;
      }
    })
    if (editableStatus)
      updatedObj.isEditable = true;
    return updatedObj;
  }

  const setSTDvalues = () => {
    let currentState = state;
    const savedApp = props.contiuedPendingApplicationObj;
    setSaveAppSave(savedApp);
    if (savedApp.EmployerBasicInformation && savedApp.EmployerBasicInformation.employeeBasicInformationId) {
      // onFilterDropDownChange(
      //     {label: savedApp.EmployerBasicInformation.firstName + " " + savedApp.EmployerBasicInformation.lastName + " " + "-" + " " + savedApp.EmployerBasicInformation.ein,
      //     value: savedApp.EmployerBasicInformation.ein})
      currentState.employeeBasicInformationId.value = savedApp.EmployerBasicInformation.employeeBasicInformationId;
      // currentState.firstName.value = savedApp.EmployerBasicInformation.firstName;
      setValueToState("firstName", savedApp.EmployerBasicInformation ? savedApp.EmployerBasicInformation.firstName : "")
      // currentState.lastName.value = savedApp.EmployerBasicInformation.lastName;
      setValueToState("lastName", savedApp.EmployerBasicInformation ? savedApp.EmployerBasicInformation.lastName : "")
      // currentState.ein.value = savedApp.EmployerBasicInformation.ein;
      setValueToState("ein", savedApp.EmployerBasicInformation ? savedApp.EmployerBasicInformation.ein : "")
      if (savedApp.EmployerBasicInformation.dob) {
        // currentState.dateOfBirth.value = moment(savedApp.EmployerBasicInformation.dob).toDate();
        setDateValueToState("dateOfBirth", savedApp.EmployerBasicInformation && savedApp.EmployerBasicInformation.dob ? moment(savedApp.EmployerBasicInformation.dob).toDate() : null)
      }
      currentState.serviceType.value = savedApp.EmployerBasicInformation.serviceType ? [savedApp.EmployerBasicInformation.serviceType] : currentState.serviceType.value;
    }

    if (savedApp.EmployeeInformation && savedApp.EmployeeInformation.EmployeeDetailsId) {
      currentState.employeeDetailsId.value = savedApp.EmployeeInformation.EmployeeDetailsId;
      // currentState.street.value = savedApp.EmployeeInformation.address;
      setValueToState("street", savedApp.EmployeeInformation ? savedApp.EmployeeInformation.address : "")
      currentState.country.value = savedApp.EmployeeInformation.countryId ? [savedApp.EmployeeInformation.countryId] : currentState.country.value;
      // currentState.state.value = savedApp.EmployeeInformation.provinceId ? [savedApp.EmployeeInformation.provinceId] : currentState.state.value;
      setValueToStateForDrpId("state", savedApp.EmployeeInformation ? savedApp.EmployeeInformation.provinceId : "", props.state, "provinceId", "provinceId")
      // currentState.city.value = savedApp.EmployeeInformation.city;
      setValueToState("city", savedApp.EmployeeInformation ? savedApp.EmployeeInformation.city : "")
      // currentState.postalCode.value = savedApp.EmployeeInformation.postalCode;
      setValueToState("postalCode", savedApp.EmployeeInformation ? savedApp.EmployeeInformation.postalCode : "")
      // currentState.phone.value = savedApp.EmployeeInformation.homeTelephoneNumber;
      setValueToState("phone", savedApp.EmployeeInformation ? normalizeInput(savedApp.EmployeeInformation.homeTelephoneNumber, "") : "")
      currentState.alternativePhone.value = savedApp.EmployeeInformation.alternateTelephoneNumber;
      // setValueToState("alternativePhone", savedApp.EmployeeInformation ? savedApp.EmployeeInformation.alternateTelephoneNumber : "")

      currentState.alternativePhoneType.value = savedApp.EmployeeInformation.isPhoneWork ? "Work" : "Mobile";
      // currentState.employeeEmail.value = savedApp.EmployeeInformation.employeeEmail
      setValueToState("employeeEmail", savedApp.EmployeeInformation ? savedApp.EmployeeInformation.employeeEmail : "")
      currentState.employeeEmailType.value = savedApp.EmployeeInformation.isEmailWork ? "Work" : "Personal";
      // currentState.prefferedLanguage.value = savedApp.EmployeeInformation.employeePreferredLanguageId ? ["CFR"] : ["ENG"];
      setValueToStateForDrpByIdValue("prefferedLanguage", savedApp.EmployeeInformation ? savedApp.EmployeeInformation.employeePreferredLanguageId : "", decidePreferredLngDrp(), "LanguageId", "LanguageId")
    }

    if (savedApp.AbsenseDetails && savedApp.AbsenseDetails.absenseDetailsId) {
      currentState.absenseDetailsId.value = savedApp.AbsenseDetails.absenseDetailsId;
      if (savedApp.AbsenseDetails.lastDayWorked)
        currentState.lastDayWorked.value = moment(savedApp.AbsenseDetails.lastDayWorked).toDate();
      if (savedApp.AbsenseDetails.firstDayAbsent)
        currentState.firstDayAbsent.value = moment(savedApp.AbsenseDetails.firstDayAbsent).toDate();
      currentState.enableReturnToWork.value = savedApp.AbsenseDetails.hasEmployeeRTW ? "Yes" : "No";
      if (savedApp.AbsenseDetails.dateRTW) {
        currentState.returnToWork.value = moment(savedApp.AbsenseDetails.dateRTW).toDate();
      }
      currentState.typeOfWork.value = savedApp.AbsenseDetails.typeRTW ? [savedApp.AbsenseDetails.typeRTW] : currentState.typeOfWork.value;
      currentState.typeOfWorkOther.value = savedApp.AbsenseDetails.specifyOtherRTW;
      currentState.alteredDuties.value = savedApp.AbsenseDetails.employeeDuties ? "Yes" : "No";
      currentState.isAlteredDutiesYes.value = savedApp.AbsenseDetails.employeeDutiesSpecification;
      if (savedApp.AbsenseDetails.stdExpiryDate) {
        currentState.sTDExpiryDate.value = moment(savedApp.AbsenseDetails.stdExpiryDate).toDate();
      }
      currentState.eligibleLTD.value = savedApp.AbsenseDetails.employeeEligibleForLTD == 0 ? "No" : savedApp.AbsenseDetails.employeeEligibleForLTD == 1 ? "Yes" : "NA";
      currentState.workPlaceAccident.value = savedApp.AbsenseDetails.conditionWorkplaceAccidentInjury == 0 ? "No" : savedApp.AbsenseDetails.conditionWorkplaceAccidentInjury == 1 ? "Yes" : "NA";
      currentState.compensationPending.value = savedApp.AbsenseDetails.compensationCasePendingSamePeriod == 0 ? "No" : savedApp.AbsenseDetails.compensationCasePendingSamePeriod == 1 ? "Yes" : "NA";
      currentState.caseForAutomobileWage.value = savedApp.AbsenseDetails.automobileWageReplacement == 0 ? "No" : savedApp.AbsenseDetails.automobileWageReplacement == 1 ? "Yes" : "NA";
    }

    savedApp.EmployeeShiftInformation && (currentState.weekWDH.value = savedApp.EmployeeShiftInformation);
    if (savedApp.EmployeementInformation && savedApp.EmployeementInformation.employementInformationId) {
      if (savedApp.EmployeementInformation.contractExpiryDate) {
        currentState.contractExpiryDate.value = moment(savedApp.EmployeementInformation.contractExpiryDate).toDate();
      }
      currentState.employementInformationId.value = savedApp.EmployeementInformation.employementInformationId;
      // currentState.region.value = savedApp.EmployeementInformation.regionId ? [savedApp.EmployeementInformation.regionId] : currentState.region.value;
      // currentState.location.value = savedApp.EmployeementInformation.divisionId ? [savedApp.EmployeementInformation.divisionId] : currentState.location.value;
      setValueToStateForDrpId("location", savedApp.EmployeementInformation.divisionId ? savedApp.EmployeementInformation.divisionId : "", props.location, "coLocationID_PK", "coLocationID_PK")
      // currentState.jobTitle.value = savedApp.EmployeementInformation.jobTitle ? savedApp.EmployeementInformation.jobTitle : currentState.jobTitle.value;
      setValueToState("jobTitle", savedApp.EmployeementInformation.jobTitle ? savedApp.EmployeementInformation.jobTitle : currentState.jobTitle.value)
      currentState.department.value = savedApp.EmployeementInformation.departmentId ? [savedApp.EmployeementInformation.departmentId] : currentState.department.value;
      // currentState.departmentName.value = savedApp.EmployeementInformation.departmentName;
      setValueToState("departmentName", savedApp.EmployeementInformation.departmentName ? savedApp.EmployeementInformation.departmentName : currentState.departmentName.value)
      currentState.planLink.value = savedApp.EmployeementInformation.planTypeId ? [savedApp.EmployeementInformation.planTypeId] : currentState.planLink.value;
      if (savedApp.EmployeementInformation.doh) {
        // currentState.dateOfHire.value = moment(savedApp.EmployeementInformation.doh).toDate();
        setDateValueToState("dateOfHire", savedApp.EmployeementInformation && savedApp.EmployeementInformation.doh ? moment(savedApp.EmployeementInformation.doh).toDate() : null)
      }
      currentState.workDay.value = savedApp.EmployeementInformation.employementStatus;
      currentState.otherEmploymentStatus.value = savedApp.EmployeementInformation.employeeStatusSpecification;
      currentState.enableWorkShift.value = savedApp.EmployeementInformation.doesEmployeeWorkShifts ? "Yes" : "No";
      currentState.workShifts.value = savedApp.EmployeementInformation.shiftSpecification;
      // currentState.managerName.value = savedApp.EmployeementInformation.managerId ? [savedApp.EmployeementInformation.managerId] : currentState.managerName.value;

      if (props.profileReducer && props.profileReducer.companyServices && props.profileReducer.companyServices.hasDemographicFileFeature) {
        setValueToStateForDrpId("managerName", savedApp.EmployeementInformation ? savedApp.EmployeementInformation.managerId : "", props.supervisorList, "supervisorID_PK", "supervisorID_PK")
      }
      else {
        currentState.fileContactManagerName.value = savedApp.EmployeementInformation.managerName ? savedApp.EmployeementInformation.managerName.trim() : currentState.managerName.value;
      }
      // currentState.fileContactManagerName.value = !props.profileReducer.companyServices.isDemoGraphicFileAvaliable ? savedApp.EmployeementInformation.managerName : "";
      currentState.managerPhone.value = savedApp.EmployeementInformation.managerPhone;
      currentState.managerEmail.value = savedApp.EmployeementInformation.managerEmail;
      currentState.futureCommunication.value = savedApp.EmployeementInformation.managerLanguagePreference ? FRENCH : ENGLISH;
    }

    if (savedApp.EmployeeQuetionConcernInfo && savedApp.EmployeeQuetionConcernInfo.EmployeeQuestionConcernId) {
      currentState.employeeQuestionConcernId.value = savedApp.EmployeeQuetionConcernInfo.EmployeeQuestionConcernId;
    }


    setState((state) => {
      return {
        ...state,
        currentState
      };
    });

    if (savedApp.employeeBasicInformation && savedApp.employeeBasicInformation.employeeBasicInformationId) {
      // onFilterDropDownChange(
      //   {label: "Jones Gregory - 001649157",
      //   value: "001649157"})
      // onFilterDropDownChange(
      //   {label: savedApp.employeeBasicInformation.firstName + " " + savedApp.employeeBasicInformation.lastName + " " + "-" + " " + savedApp.employeeBasicInformation.ein,
      //   value: savedApp.employeeBasicInformation.ein})
    }

    savedApp.EmployerBasicInformation && props.setCurrentFormStep(savedApp.EmployerBasicInformation.stepsCompleted);
    props.closeRemoveModal();
  }

  //Set initial step & initial state after first render
  useEffect(() => {
    props.setMaxStep(4);
    props.setMinStep(1);
    props.setCurrentFormStep(1);
    onDiscard();
    props.resetErsApplicationUrl();
  }, []);

  // clean on unmount
  useEffect(() => {
    return () => {
      onDiscard();
      props.resetErsApplicationUrl();
    };
  }, []);

  //Reset form to its initial state after form submit action
  useEffect(() => {
    if (props.isAdded) {
      props.resetIsAdded(false);
      props.setMaxStep(4);
      props.setMinStep(1);
      props.setCurrentFormStep(1);
      onDiscard();
      props.commonReducer && props.commonReducer.successMessage && goToHomeOrNot(props.commonReducer.successMessage);
      props.resetSuccessMessage("");
      resetFileInput();
    }
  }, [props.isAdded]);

  // Execuate funtion on every step change
  useEffect(() => onStepCountChange(), [props.stepCount]);

  // Execuate funtion on employment status dropdown change
  useEffect(() => onEmploymentStatusChange(), [state.employmentStatus.value]);

  // Execuate funtion on type of work change
  useEffect(() => onTypeOfWorkChange(), [state.typeOfWork.value]);

  // Execuate funtion on search by value change
  useEffect(() => onSearchFilterChange(), [state.searchBy.value]);

  // Execuate funtion on client information value change
  useEffect(() => onClientChange(), [
    utilities.extractFirstValueOfArray(state.clientInfo.value),
  ]);

  // Execuate funtion on enabling return to work
  useEffect(() => onReturnToWorkChange(), [state.enableReturnToWork.value]);

  // Execuate funtion on work day value change
  // useEffect(() => onWorkDayChange(), [state.workDay.value]);

  // Execuate funtion on observed change
  useEffect(() => onObservedChange(), [state.observedChanges.value]);

  // Execuate funtion on behavior value change
  useEffect(() => onBehaviorChange(), [state.behaviorChanges.value]);

  // Execuate funtion on client info change
  useEffect(() => mapClientInfoById(), [props.clientInfoById]);

  // Execuate funtion on  administering the payroll service
  useEffect(() => onAdministerPayrollChange(), [state.administerPayroll.value]);

  // Execuate funtion on Manager Name dropdown change
  useEffect(() => onManagerNameChange(), [
    utilities.extractFirstValueOfArray(state.managerName.value),
  ]);

  //Execuate funtion on sidebar language change
  // useEffect(() => setInitialStep(), [props.i18nReducerLang]);

  // Setting default Value to Region
  useEffect(() => {
    if (Array.isArray(props.region) && props.region.length === 1) {
      setState((state) => {
        return {
          ...state,
          region: utilities.convertIntoObject(
            utilities.convertIntoArray(props.region[0].coRegionID_PK),
            state.region
          ),
        };
      });
    }
  }, [props.region, props.isAdded]);

  // Get States by country
  useEffect(() => {
    if (state.country.value && state.country.value.length)
      props.getStates(utilities.extractFirstValueOfArray(state.country.value))
  }, [state.country.value])

  useEffect(() => {
    if (saveAppSave && !Array.isArray(saveAppSave) && saveAppSave.EmployerBasicInformation.employeeBasicInformationId > 0) {
      setState((state) => {
        return {
          ...state,
          ['state']: setValueToStateForDrpId("state", saveAppSave.EmployeeInformation ? saveAppSave.EmployeeInformation.provinceId : "", props.state, "provinceId", "provinceId"),
        };
      });
    }
    else {
      setState((state) => {
        return {
          ...state,
          ['state']: setValueToStateForDrpId("state", selectedValueSave ? selectedValueSave.provinceId : "", props.state, "provinceId", "provinceId"),
        };
      });
    }


  }, [props.state])

  // Setting default Value to Region
  useEffect(() => {
    if (Array.isArray(props.planLink) && props.planLink.length) {
      // let flag = false;
      // props.planLink.map((planlink)=>{
      //   if(planlink.defaultPlan){
      //     flag = true;
      //   }
      // })
      // if(flag){
      //   let { payRollID_PK } = props.planLink.find((link) => link.defaultPlan);
      // }

      let payRollID_PK = undefined;
      props.planLink.map((link) => {
        if (link.defaultPlan) {
          payRollID_PK = link.payRollID_PK;
        }
      })

      // let { payRollID_PK } = props.planLink.find((link) => link.defaultPlan);
      if (payRollID_PK) {
        setState((state) => {
          return {
            ...state,
            planLink: payRollID_PK && utilities.convertIntoObject(
              utilities.convertIntoArray(payRollID_PK),
              state.planLink
            ),
          };
        });
      }
    }
  }, [props.planLink, props.isAdded]);

  const nextStep = () => {
    if (props.stepCount < props.maxStep) {
      props.setCurrentFormStep(props.stepCount + 1);
    }
  };

  const previousStep = () => {
    if (props.stepCount > props.minStep) {
      props.setCurrentFormStep(props.stepCount - 1);
      document.querySelector("body").scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }
  };

  const onSearchClick = () => {
    if (
      state.searchValue.value.trim().length &&
      state.searchBy.value === "EIN"
    ) {
      props.getClientInfoByIdOrEin(state.searchValue.value.trim(), 0);
    } else {
      state.searchValue.error = EIN_ERROR;
      setState((previousState) => {
        return {
          ...previousState,
          searchValue: { ...state.searchValue },
        };
      });
    }
  };

  const download = (filePath) => {
    const link = document.createElement("a");
    link.href = filePath;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const removeCompanyAttachmentsAction = (
    filePath,
    isDocs,
    index,
    allAttachments
  ) => {
    props.removeFiles(filePath, isDocs, index, allAttachments);
    resetFileInput();
    props.closeRemoveModal();
  };

  const removeFile = (filePath, isDocs, index, allAttachments) =>
    props.openSetModalAction(
      <ConfirmationModalPopup
        {...props}
        onYesClick={() =>
          removeCompanyAttachmentsAction(
            filePath,
            isDocs,
            index,
            allAttachments
          )
        }
      />,
      MODAL_SIZE.MODAL_SM
    );

  const addDescription = (index, attachmentDescription, attachment) =>
    props.openSetModalAction(
      <AttachmentDescription
        {...props}
        index={index}
        attachmentDescription={attachmentDescription}
        attachment={attachment}
      />,
      MODAL_SIZE.MODAL_SM
    );

  const handleFileUpload = (event) => {
    let { files } = event.target;
    let formData = new FormData();
    if (files[0]) {
      formData.append("file", files[0]);
      formData.append("authToken", utilities.getTokenHeader().authToken);
      props.uploadFiles(formData, props.attachment, props);
    }

    event.target.value = ''
  };

  const handleWeekShift = (event) => {

    let { name, value } = event.target;

    let updatedObj = state.weekWDH;
    updatedObj.value.forEach((day) => {
      if (day.shift === name) {
        day.hours = value;
      }
    });

    setState((state) => {
      return {
        ...state,
        weekWDH: updatedObj,
      };
    });
  };

  const normalizeInput = (value, previousValue) => {
    if (!value) return value;
    //remove any charater without alphnumeric
    const currentValue = value.replace(/[^\d]/g, "");
    const cvLength = currentValue.length;

    if (!previousValue || value.length) {
      if (cvLength < 4) {
        return currentValue;
      } else if (cvLength < 7) {
        return `(${currentValue.slice(0, 3)})-${currentValue.slice(3)}`;
      } else {
        return `(${currentValue.slice(0, 3)})-${currentValue.slice(
          3,
          6
        )}-${currentValue.slice(6, 10)}`;
      }
    }
  };

  const handleChanges = (event) => {
    let { name, value, checked, type } = event.target;

    let updatedObj = state[name];
    updatedObj.value = type === "checkbox" ? checked : value;

    if (state.isSubmitOnce.value) {
      FormValidation();
    }

    if (
      name === "phone" ||
      name === "alternativePhone" ||
      name === "managerPhone"
    ) {
      setState((previousState) => {
        return {
          ...previousState,
          [name]: utilities.convertIntoObject(
            normalizeInput(updatedObj.value, previousState[name][value]),
            previousState[name]
          ),
        };
      });
    } else {
      setState((state) => {
        return {
          ...state,
          [name]: updatedObj,
        };
      });
    }
  };

  const onDateChange = (value, name) => {
    let updatedObj = state[name];
    updatedObj.value = value;

    if (state.isSubmitOnce.value) {
      FormValidation();
    }

    setState((state) => {
      return { ...state, [name]: updatedObj };
    });
  };

  const addMoreElement = () => {
    let elementToPush = {
      ...initialState.previousStdLtd.value[0],
      default: false,
    };

    state.previousStdLtd.value.push(elementToPush);

    setState((previousState) => {
      return { ...previousState, previousStdLtd: state.previousStdLtd };
    });
  };

  const removeElement = (elementIndex) => {
    state.previousStdLtd.value.splice(elementIndex, 1);

    setState((previousState) => {
      return { ...previousState, previousStdLtd: state.previousStdLtd };
    });
  };

  const onStdLtdDateChange = (value, name, index) => {
    let updatedValue = { ...state.previousStdLtd.value[index] };
    updatedValue[name] = value;

    state.previousStdLtd.value.splice(index, 1, updatedValue);

    setState((previousState) => {
      return { ...previousState, previousStdLtd: state.previousStdLtd };
    });
  };

  const onDropDownChange = (event) => {
    let { name, value } = event;

    let updatedObj = state[name];
    updatedObj.value = value;

    if (state.isSubmitOnce.value) {
      FormValidation();
    }

    setState((state) => {
      return { ...state, [name]: updatedObj };
    });
  };

  const onStdLtdDropdownChange = (event, index) => {
    let { name, value } = event;

    let updatedValue = { ...state.previousStdLtd.value[index] };
    updatedValue[name] = value;

    state.previousStdLtd.value.splice(index, 1, updatedValue);

    setState((previousState) => {
      return { ...previousState, previousStdLtd: state.previousStdLtd };
    });
  };

  const onAddJob = () => {
    props.openSetModalAction(
      <JobDetailModal {...props} locationID={state.location.value} />,
      MODAL_SIZE.MODAL_SM // For small modal
    );
  };

  const onAddManager = () => {
    props.openSetModalAction(
      <ManagerDetailModal
        {...props}
        jobID={state.jobTitle.value}
        locationID={state.location.value}
      />,
      MODAL_SIZE.MODAL_SM
    );
  };

  //Manager Email change
  useEffect(() => {
    if (props.profileReducer && props.profileReducer.companyServices && !props.profileReducer.companyServices.hasDemographicFileFeature) {
      let fupdatedObj = state["fileContactManagerName"];
      fupdatedObj["error"] = "";
      fupdatedObj["validation"] = {
        required: true
      };
      setState((state) => {
        return {
          ...state,
          ['fileContactManagerName']: fupdatedObj,
        };
      });
    }
    else {
      let updatedObj = state["managerName"];
      updatedObj["validation"] = {
        required: true
      };
      setState((state) => {
        return {
          ...state,
          ['managerName']: updatedObj,
        };
      });
    }
  }, [props.stepCount == 2])


  const FormValidationForSaveForLater = () => {
    for (const property in state) {
      if (
        state[property]?.validation &&
        Object.keys(state[property].validation).length
      ) {
        let propertywithnorequired = state[property];
        let validationobj = {}
        // propertywithnorequired.validation;
        Object.keys(propertywithnorequired.validation).forEach(function (key) {
          if (key != "required" && key != "isDate") {
            validationobj[key] = propertywithnorequired.validation[key];
          }
          // validationobj.required=false;
        });
        // propertywithnorequired.validation && propertywithnorequired.validation.keys((requiredProperty)=>{
        //   if(requiredProperty.required==true) 
        //   validationobj.required=false;
        // })
        propertywithnorequired.validation = validationobj;
        let validatedObj = validation(propertywithnorequired, props.context);
        setState((state) => {
          return {
            ...state,
            [property]: validatedObj,
          };
        });
      }
    }
  };

  const FormValidation = () => {
    for (const property in state) {
      if (
        state[property]?.validation &&
        Object.keys(state[property].validation).length
      ) {
        let validatedObj = validation(state[property], props.context);
        setState((state) => {
          return {
            ...state,
            [property]: validatedObj,
          };
        });
      }
    }
  };

  const onDiscard = () => {
    props.setIsSearch(false);
    setState((state) => {
      return { ...initialState };
    });
    props.setAttachment([]);
    props.setClientInfoByIdOrEin(undefined);
    props.resetContiuedPendingApplicationObj();
  };

  const resetFileInput = () => {
    if (attachmentRef && attachmentRef.current && attachmentRef.current.value)
      attachmentRef.current.value = "";
  };

  const setValueToStateForDrp = (key, valueToBeSet, findFromOptions, optionsKey, optionsValue) => {
    let updatedObj = state[key];
    let editableStatus = true;
    if (!valueToBeSet) {
      updatedObj.value = [];
    }
    Array.isArray(findFromOptions) && findFromOptions.map((option) => {
      if (option[optionsValue].trim().toLowerCase() === valueToBeSet.trim().toLowerCase()) {
        updatedObj.value = [option[optionsKey]]
        updatedObj.isEditable = false;
        editableStatus = false;
      }
    })
    if (editableStatus)
      updatedObj.isEditable = true;
    return updatedObj;
  }

  const setValueToStateForDrpById = (key, valueToBeSet, findFromOptions, optionsKey, optionsValue) => {
    let updatedObj = state[key];
    let editableStatus = true;
    if (!valueToBeSet) {
      updatedObj.value = [];
    }
    Array.isArray(findFromOptions) && findFromOptions.map((option) => {
      let optionVal = option[optionsKey];
      if (optionVal.trim() === valueToBeSet) {
        updatedObj.value = [option[optionsKey]]
        updatedObj.isEditable = false;
        editableStatus = false;
      }
    })
    if (editableStatus)
      updatedObj.isEditable = true;
    return updatedObj;
  }

  const setDateValueToState = (key, valueToBeSet) => {
    let updatedObj = state[key];
    updatedObj.value = valueToBeSet;
    if (valueToBeSet) {
      updatedObj.isEditable = false;
    }
    else {
      updatedObj.isEditable = true;
    }
    return updatedObj;
  }

  const setValueToState = (key, valueToBeSet) => {
    let updatedObj = state[key];
    updatedObj.value = valueToBeSet ? valueToBeSet.trim() : "";
    if (valueToBeSet) {
      updatedObj.isEditable = false;
    }
    else {
      updatedObj.isEditable = true;
    }
    return updatedObj;
  }

  const decidePreferredLngDrp = () => {
    let defaultPreferLang = PREFERREDLANGUAGEDRPDATA;
    if (props.i18nReducerLang === "en-US") {
      defaultPreferLang = PREFERREDLANGUAGEDRPDATA;
    } else {
      defaultPreferLang = PREFERREDLANGUAGEDRPDATA_FRENCH;
    }

    return defaultPreferLang;
  };

  const onFilterDrpChange = (selectedValue) => {
    setselectedValueSave(selectedValue);
    setState((state) => {
      return {
        ...state,
        firstName: setValueToState("firstName", selectedValue ? selectedValue.clientFirstName : ""),
        lastName: setValueToState("lastName", selectedValue ? selectedValue.clientLastName : ""),
        dateOfBirth: setDateValueToState("dateOfBirth", selectedValue && selectedValue.dob ? moment(selectedValue.dob).toDate() : null),
        phone: setValueToState("phone", selectedValue ? normalizeInput(selectedValue.homePhone, "") : ""),
        // alternativePhone: setValueToState("alternativePhone", selectedValue ? selectedValue.workPhone : ""),
        ein: setValueToState("ein", selectedValue ? selectedValue.externalID : ""),
        employeeEmail: setValueToState("employeeEmail", selectedValue ? selectedValue.emailAddress : ""),
        street: setValueToState("street", selectedValue && (selectedValue.address1 || selectedValue.address2) ? selectedValue.address1 + " " + selectedValue.address2 : ""),
        postalCode: setValueToState("postalCode", selectedValue ? formatPostalCode(selectedValue.zip) : ""),
        city: setValueToState("city", selectedValue ? selectedValue.city : ""),
        // state: setValueToStateForDrp("state", selectedValue ? selectedValue.province : "", props.state, "provinceId", "province"),
        //departmentName: setValueToState("departmentName", selectedValue ? selectedValue.department : ""),
        location: setValueToStateForDrpId("location", selectedValue ? selectedValue.departmentId : "", props.location, "coLocationID_PK", "coLocationID_PK"),
        jobTitle: setValueToState("jobTitle", selectedValue ? selectedValue.jobtitle : ""),
        country: setValueToStateForDrpId("country", selectedValue ? selectedValue.country : "", props.country, "countryId", "countryName"),
        state: setValueToStateForDrpId("state", selectedValue ? selectedValue.provinceId : "", props.state, "provinceId", "provinceId"),
        prefferedLanguage: setValueToStateForDrpById("prefferedLanguage", selectedValue && (selectedValue.language ? selectedValue.language : "CFR"), decidePreferredLngDrp(), "LanguageId", "Language"),
        managerName: setValueToStateForDrp("managerName", selectedValue ? selectedValue.managerName : "", props.supervisorList, "supervisorID_PK", "primaryName"),
        dateOfHire: setDateValueToState("dateOfHire", selectedValue && selectedValue.dateOfHire ? moment(selectedValue.dateOfHire).toDate() : null),
      }
    })
  }

  const isFormValid = (currentStepCount) => {
    let isValid = true;
    for (const property in state) {
      if (
        state[property]?.validation &&
        Object.keys(state[property].validation).length
      ) {
        if (
          state[property]?.error.length > 0 &&
          currentStepCount === state[property]?.step
        ) {
          isValid = false;
        }
      }
    }
    return isValid;
  };

  const setInitialStep = () => {
    props.setCurrentFormStep(1);
    setState((state) => {
      return {
        ...state,
        typeOfWork: utilities.convertIntoObject(
          initialState.typeOfWork.value,
          state.typeOfWork
        ),
      };
    });
  };

  const formatPostalCode = (postalCode) => {
    let postalcode = Array.from(postalCode);
    let formatedPostal = "";
    Array.isArray(postalcode) && postalcode.length && postalcode.map((partofpostal, i) => {
      if (i <= 6) {
        if (i == 3) {
          if (partofpostal == " ")
            formatedPostal = formatedPostal + partofpostal;
          else {
            formatedPostal = formatedPostal + " ";
            formatedPostal = formatedPostal + partofpostal;
          }
        }
        else
          formatedPostal = formatedPostal + partofpostal;

      }
    })
    return formatedPostal;
  }

  const goToHomeOrNot = (message) => {
    if (props.stepCount == props.maxStep) {
      swal({
        text: message,
        icon: "success",
        buttons: [{
          visible: true,
          text: props.context.t("Form.Submit.Close")
        }, {
          cancel: true,
          visible: true,
          text: props.context.t("Form.Submit.Download.Application")
        }
        ],
        dangerMode: false,
      })
        .then((isDownload) => {
          if (isDownload) {
            if (props.ersFormPdfLink) {
              utilities.download(props.ersFormPdfLink);
              history.push("/dashboard");
            }
            else {
              history.push("/dashboard");
            }
          } else {
            history.push("/dashboard");
          }
        });
    }
    else {
      swal(message)
        .then((value) => {
          // swal(`The returned value is: ${value}`);
          history.push("/dashboard");
        });
    }

  }

  const onSTDApiCall = (isPassed) => {
    let attachments = [...props.attachment];

    attachments = attachments.map((attachment) => {
      return {
        employeeBasicInfoId_FK: state.employeeBasicInformationId.value,
        fileType: attachment.format,
        fileUploadPath: attachment.path,
        fileLength: attachment.size,
        uploadFileName: attachment.fileName,
        isDoc: attachment.isDoc,
        attachmentDescription: attachment.attachmentDescription,
        attachmentDataId: attachment.attachmentDataId,
      };
    });

    let convertValueForOptions = (value) => {
      if (value === "No") {
        return 0;
      }
      if (value === "Yes") {
        return 1;
      }
      if (value === "NA") {
        return 2;
      }
    };

    let employeeShiftInformationData = state.weekWDH.value.map(
      ({ ...day }) => {

        if (!day.hours.toString().length) {
          day.hours = "0.0";
        }
        day.shift = props.context.t(day.shift);
        day.employeeShiftInformationId = day.employeeShiftInformationId;
        day.employementInformationId_FK = state.employementInformationId.value;
        day.employeeBasicInfoId = state.employeeBasicInformationId.value;
        return day;
      }
    );


    let workObservationData = [...state.previousStdLtd.value];

    workObservationData = workObservationData
      .map((observation) => {
        if (
          observation.stdLtd.length ||
          observation.stdLtdDate.length ||
          observation.stdLtdRtwDate.length
        ) {
          let observationsToReturn = {
            typeofCases: utilities.extractFirstValueOfArray(
              observation.stdLtd
            ),
            dateOfCase: utilities.toAPIDateFormat(observation.stdLtdDate),
            dateOfRTW: utilities.toAPIDateFormat(observation.stdLtdRtwDate),
            workObservationId: state.workObservationId.value,
            employerQuestionsConcernsId: state.employeeQuestionConcernId.value
          };
          return observationsToReturn;
        }
      })
      .filter((observation) => observation);

    let stdData = {
      employeeBasicInformation: {
        employeeBasicInformationId: state.employeeBasicInformationId.value,
        firstName: state.firstName.value,
        lastName: state.lastName.value,
        ein: state.ein.value,
        dob: utilities.toAPIDateFormat(state.dateOfBirth.value),
        serviceType: utilities.extractFirstValueOfArray(
          state.serviceType.value
        ),
        companyId: props.managersDetails.companyId,
        isCompleted: isPassed,
        stepsCompleted: props.stepCount,
        isGeneratePDFinEnglish:
          props.i18nReducerLang === PREFERED_LANGUAGE_KEYS.EnglishUS
            ? true
            : false,
      },
      employeeDetails: {
        EmployeeDetailsId: state.employeeDetailsId.value,
        employeeBasicInfomationId_FK: state.employeeBasicInformationId.value,
        address: state.street.value,
        countryId: utilities.extractFirstValueOfArray(state.country.value),
        provinceId: utilities.extractFirstValueOfArray(state.state.value),
        city: state.city.value,
        postalCode: state.postalCode.value,
        homeTelephoneNumber: state.phone.value,
        alternateTelephoneNumber: state.alternativePhone.value,
        isPhoneWork:
          state.alternativePhoneType.value === "Work" ? true : false,
        employeeEmail: state.employeeEmail.value,
        isEmailWork:
          state.employeeEmailType.value === "Work" ? true : false,
        employeePreferredLanguageId: convertLanguageToBool(
          utilities.extractFirstValueOfArray(state.prefferedLanguage.value)
        ),
      },

      employmentInformation: {
        employementInformationId: state.employementInformationId.value,
        employeeBasicInformationId: state.employeeBasicInformationId.value,
        // regionId: utilities.extractFirstValueOfArray(state.region.value),
        divisionId: utilities.extractFirstValueOfArray(
          state.location.value
        ),
        jobTitle: state.jobTitle.value,
        departmentId: utilities.extractFirstValueOfArray(
          state.department.value
        ),
        departmentName: state.departmentName.value,
        planTypeId: utilities.extractFirstValueOfArray(
          state.planLink.value
        ),
        doh: utilities.toAPIDateFormat(state.dateOfHire.value),
        employementStatus: state.workDay.value,
        employeeStatusSpecification: state.otherEmploymentStatus.value,
        doesEmployeeWorkShifts:
          state.enableWorkShift.value === "Yes" ? true : false,
        shiftSpecification: state.workShifts.value,
        createdByManager: props.managersDetails.managerId,
        contractExpiryDate: utilities.toAPIDateFormat(state.contractExpiryDate.value),
        isDemoGraphicFileAvaliable: props.profileReducer && props.profileReducer.companyServices && props.profileReducer.companyServices.hasDemographicFileFeature,
        fileContactManagerName: state.fileContactManagerName.value,
        managerId: utilities.extractFirstValueOfArray(state.managerName.value),
        managerPhone: state.managerPhone.value,
        managerEmail: state.managerEmail.value,
        isCompleted: isPassed,
        stepsCompleted: props.stepCount,
        managerLanguagePreference: convertPreferredLanguageBoolean(
          state.futureCommunication.value
        ),
      },
      employeeShiftInformation: employeeShiftInformationData,
      absenceDetails: {
        absenseDetailsId: state.absenseDetailsId.value,
        employeeBasicInformationId: state.employeeBasicInformationId.value,
        lastDayWorked: utilities.toAPIDateFormat(state.lastDayWorked.value),
        firstDayAbsent: utilities.toAPIDateFormat(state.firstDayAbsent.value),
        hasEmployeeRTW:
          state.enableReturnToWork.value === "Yes" ? true : false,
        dateRTW: utilities.toAPIDateFormat(state.returnToWork.value),
        typeRTW: utilities.extractFirstValueOfArray(state.typeOfWork.value),
        specifyOtherRTW: state.typeOfWorkOther.value,
        employeeDuties: state.alteredDuties.value == "Yes" ? true : false,
        employeeDutiesSpecification: state.isAlteredDutiesYes.value,
        stdExpiryDate: utilities.toAPIDateFormat(state.sTDExpiryDate.value),
        employeeEligibleForLTD: convertValueForOptions(
          state.eligibleLTD.value
        ),
        compensationCasePendingSamePeriod: convertValueForOptions(
          state.compensationPending.value
        ),
        conditionWorkplaceAccidentInjury: convertValueForOptions(
          state.workPlaceAccident.value
        ),
        automobileWageReplacement: convertValueForOptions(
          state.caseForAutomobileWage.value
        ),
      },
      employeePayRollInfo: {
        employeeBasicInformationId: state.employeeBasicInformationId.value,
        isOncAdministratorPayrollService: state.administerPayroll.value,
        rctFederalNEC: state.federalNetExemptionCode.value,
        federalNCE: state.federalNetExemption.value,
        rctProvincialNEC: state.provincialNetExemptionCode.value,
        provincialNEC: state.provincialNetExemption.value,
        salary: Number(state.salary.value),
        salaryPer: state.salaryPer.value,
        payFrequency: state.payFrequency.value,
        yearToDateCPP: Number(state.totalPaidOutCpp.value),
        yearToDateEI: Number(state.totalPaidOutEi.value),
        yearToDateQPIP: Number(state.totalPaidOutQpip.value),
        maxedCPP: Number(state.maxedCpp.value),
        maxedEI: Number(state.maxedEi.value),
        maxedQPIP: Number(state.maxedQpip.value),
        payRollVerbiage: state.payrollVerbiage.value,
        additionalNotes: state.additionalNotes.value,
      },
      employeeQuestionConcern: {
        EmployeeQuestionConcernId: state.employeeQuestionConcernId.value,
        employeeBasicInformationId_FK: state.employeeBasicInformationId.value,
        RelevantInfoforReviewEmpQues: state.informationForReview.value,
        RecentChangesInProdQualityQty:
          state.observedChanges.value === "Yes" ? true : false,
        RecentChangesInProdQualityQtySepcification:
          state.isObservedChanges.value,
        RecentChangesInBehavior:
          state.behaviorChanges.value === "Yes" ? true : false,
        RecentChangesInBehaviorSepcification: state.isBehaviorChanges.value,
        oncidiumReceipt: state.discuss.value === "Yes" ? true : false,
        additionalNotesAdd: state.additionalNotesAdd.value,
      },
      workObservation: workObservationData,
      stdEmployeeAttachments: attachments
    };
    if (
      stdData.stdEmployeeAttachments.every(
        (attachment) => attachment.attachmentDescription
      )
    ) {
      props.addstdemployeestatement(stdData);
      // props.stepCount !== props.maxStep && props.setOnSubmit(true);  
    } else {
      props.showAlertError(
        "STD-Employer-Statement.form.Attachment.label.text.Description",
        "STD-Employer-Statement.form.error.required"
      );
    }
  }

  const onSubmit = (isPassed = false, moveToNextPage = true) => {
    // setIsYourFirstVisit(false);
    if (urlLocation && urlLocation.state && urlLocation.state.isRedirectFromNotification) {
      let tempUrlLocation = urlLocation;
      tempUrlLocation.state.isRedirectFromNotification = false;
      setUrlLocation(tempUrlLocation);
    }
    setState((state) => {
      return {
        ...state,
        isSubmitOnce: utilities.convertIntoObject(true),
      };
    });

    if (props.stepCount !== props.maxStep) {
      document.querySelector("body").scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }

    if (!moveToNextPage && props.stepCount !== props.maxStep) {
      FormValidationForSaveForLater();
      if (isFormValid(props.stepCount)) {
        onSTDApiCall(isPassed);
      }
    }
    else {
      FormValidation();

      if (isFormValid(props.stepCount)) {



        if (moveToNextPage) {
          nextStep();
        }
        else {
          onSTDApiCall(isPassed);
        }
      } else {
        // //scroll to the top
        document.querySelector("body").scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        });

        ///How to get First error in particular step
        let errorObject = [];

        for (const property in state) {
          if (state[property].step === props.stepCount && state[property].error)
            errorObject.push({
              name: property,
              label: state[property].label,
              error: state[property].error,
              positionCount: state[property].positionCount,
            });
        }
        errorObject.sort(function (a, b) {
          return a.positionCount - b.positionCount;
        });

        //Setting focus on first error field
        if (state[errorObject[0].name] && state[errorObject[0].name].ref && state[errorObject[0].name].ref.current && state[errorObject[0].name].ref.current.focus) {
          state[errorObject[0].name] && state[errorObject[0].name].ref && state[errorObject[0].name].ref.current && state[errorObject[0].name].ref.current.focus();
        } else {
          state[errorObject[0].name] && state[errorObject[0].name].ref && state[errorObject[0].name].ref.current && state[errorObject[0].name].ref.current.setFocus();
        }
      }
    }
  };

  switch (props?.stepCount) {
    case 1:
      return (
        <div>
          <div className="Dashboard-Content">
            <DisplayEmployeeName context={props.context} />
            <Step
              currentStep={props.stepCount}
              setCurrentFormStep={props.setCurrentFormStep}
              context={props.context}
            />
          </div>
          {/* {props.ersFormPdfLink ? (
            <div className="alert alertSuccess" role="alert">
              ERS form submitted successfully.&nbsp;
              <a onClick={() => download(props.ersFormPdfLink)}>
                Click
              </a> here
              to download ERS application.
            </div>
          ) : null} */}
          <div className="alert alertInfo WC-label-text" role="alert">
            {props.context.t(
              "STD.TEXT-TITLE"
            )}
          </div>
          <EmployerStatement
            state={state}
            onSubmit={onSubmit}
            handleChanges={handleChanges}
            props={props}
            onFilterDropDownChange={onFilterDropDownChange}
            onFilterDrpChange={onFilterDrpChange}
            onDropDownChange={onDropDownChange}
            onDiscard={onDiscard}
            onSearchClick={onSearchClick}
            onDateChange={onDateChange}
            isFormValid={isFormValid(props.stepCount)}
          />
        </div>
      );
    case 2:
      return (
        <div>
          <div className="Dashboard-Content">
            <DisplayEmployeeName context={props.context} />
            <Step
              currentStep={props.stepCount}
              setCurrentFormStep={props.setCurrentFormStep}
              context={props.context}
            />
          </div>
          <EmployeeDetails
            state={state}
            onDateChange={onDateChange}
            handleChanges={handleChanges}
            handleWeekShift={handleWeekShift}
            onDropDownChange={onDropDownChange}
            onSubmit={onSubmit}
            props={props}
            previousStep={previousStep}
            isFormValid={isFormValid(props.stepCount)}
            onAddJob={onAddJob}
            onAddManager={onAddManager}
            profileReducer={props.profileReducer}
          />
        </div>
      );
    case 3:
      return (
        <div>
          <div className="Dashboard-Content">
            <DisplayEmployeeName context={props.context} />
            <Step
              currentStep={props.stepCount}
              setCurrentFormStep={props.setCurrentFormStep}
              context={props.context}
            />
          </div>
          <AbsenceDetails
            state={state}
            onDateChange={onDateChange}
            handleChanges={handleChanges}
            onSubmit={onSubmit}
            props={props}
            previousStep={previousStep}
            onDropDownChange={onDropDownChange}
            isFormValid={isFormValid(props.stepCount)}
          />
        </div>
      );
    case 4:
      return (
        <div>
          <div className="Dashboard-Content">
            <DisplayEmployeeName context={props.context} />
            <Step
              currentStep={props.stepCount}
              setCurrentFormStep={props.setCurrentFormStep}
              context={props.context}
            />
          </div>
          <EmployerDetailsFinal
            state={state}
            onDateChange={onDateChange}
            handleChanges={handleChanges}
            onSubmit={onSubmit}
            props={props}
            previousStep={previousStep}
            onDropDownChange={onDropDownChange}
            onStdLtdDropdownChange={onStdLtdDropdownChange}
            onStdLtdDateChange={onStdLtdDateChange}
            addMoreElement={addMoreElement}
            removeElement={removeElement}
            handleFileUpload={handleFileUpload}
            download={download}
            removeFile={removeFile}
            addDescription={addDescription}
            attachmentRef={attachmentRef}
            isFormValid={isFormValid(props.stepCount)}
          />
        </div>
      );
    default:
      return null;
  }
};
export default STD;
